import React from "react";
import AlertTable from "../../components/AlertTable";
import { Typography } from "antd";

const { Title } = Typography;

const AlertsNotifications: React.FC = () => {
  return (
    <div className="px-6 h-full w-full flex flex-col">
      <Title level={2} className="my-6">
        Trap Maintenance
      </Title>
      <AlertTable />
    </div>
  );
};

export default AlertsNotifications;
